module.exports = __webpack_public_path__ + "images/corners/Double Taos.202a4042971beed2082bab5ca81c1e53.jpg";